var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-reasons',{attrs:{"subtitle":_vm.$t('result.scan_error_detected'),"tiles":_vm.tiles}})}
var staticRenderFns = []

export { render, staticRenderFns }